import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetTerminationTypeModel } from "@core/model/query-model-termination-type";
import { terminationTypeFormDefault } from "./form.default";
import { TerminationTypeFormSchema } from "./form.rule";

export const useFormDefaultTerminationType = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTerminationTypeModel | undefined) => {
    return !cachedValue
      ? terminationTypeFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as TerminationTypeFormSchema);
  };

  return {
    getDefault,
  };
};
